<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-12 10:52:12
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-12 11:05:45
 * @FilePath: /chaoyongtuan/src/views/shopManage/components/extensionDrawer/tableCell/extendCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div class="yx-color-text-primary" v-if="row.enable">是</div>
        <div class="yx-color-text-primary" v-else>
            <span>否</span>
            <span class="ml-8 color-p-4 pointer">
                <el-tooltip class="item" effect="dark" :content="row.disable_reason" placement="top-start">
                    <span>原因</span>
                </el-tooltip>
            </span>
        </div>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
};
</script>